import Ajax from '../util/ajax';
export function fetchZigbeeNodeDescriptor(zigbee_node_id) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/nodedesc';
        ajax.post(url);
    };
}
